import { useCallback, useState } from "react";

// 登記取得履歴テーブル用のクライアント側ページネーション hook。
// 取得成功時にページを先頭へ戻す resetPage() を備える。

const DEFAULT_PAGE = 0;
/** 初期表示行数。同一物件への大量取得は稀なため 10 とする。 */
const DEFAULT_PAGE_SIZE = 10;

interface IUseGridPaginationReturnType {
  page: number;
  pageSize: number;
  changePage: (pageIndex: number) => void;
  changePageSize: (pageSize: number) => void;
  /** ページサイズを保持したままページを先頭へ戻す（取得成功時のリセット用）。 */
  resetPage: () => void;
}

export const useGridPagination = (): IUseGridPaginationReturnType => {
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  // 3 関数は関数同一性を安定させる（毎レンダリングの再生成を防ぐ）。
  // resetPage は呼び出し側の useEffect 依存に入るため、安定参照でないと effect が無駄に再実行され、
  // DataGridPro へ渡す onPageChange/onPageSizeChange も毎回新規参照になり React.memo を妨げる。
  const changePage = useCallback((page: number): void => {
    setPage(page);
  }, []);

  const changePageSize = useCallback((pageSize: number): void => {
    setPage(DEFAULT_PAGE);
    setPageSize(pageSize);
  }, []);

  const resetPage = useCallback((): void => {
    setPage(DEFAULT_PAGE);
  }, []);

  return {
    page,
    pageSize,
    changePage,
    changePageSize,
    resetPage,
  };
};
